import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("dl_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export function trackVisit() {
  try {
    if (sessionStorage.getItem("dl_tracked")) return;
    sessionStorage.setItem("dl_tracked", "1");
    let source = "bezpośrednie";
    const ref = document.referrer.toLowerCase();
    if (ref.includes("google")) source = "google";
    else if (ref.includes("facebook") || ref.includes("fb.")) source = "facebook";
    else if (ref.includes("instagram")) source = "instagram";
    else if (ref.includes("ceneo")) source = "ceneo";
    api.post("/analytics/track", { source, path: window.location.pathname }).catch(() => {});
  } catch (e) {}
}
